import LazyLoad from 'vanilla-lazyload';

$(function() {
    new LazyLoad({
        use_native: true
    });
});
